import { render, staticRenderFns } from "./NoDataBadgeList.vue?vue&type=template&id=13774ede&scoped=true&"
import script from "./NoDataBadgeList.vue?vue&type=script&lang=js&"
export * from "./NoDataBadgeList.vue?vue&type=script&lang=js&"
import style0 from "./NoDataBadgeList.vue?vue&type=style&index=0&id=13774ede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13774ede",
  null
  
)

export default component.exports